import React from 'react';

export default function GoogleFormEmbed() {
  return (
    <div className="flex flex-col items-center min-h-screen bg-gray-100 p-4">
      
      <main className="w-full max-w-4xl bg-white rounded-lg shadow-md overflow-hidden">
        <iframe 
          src="https://docs.google.com/forms/d/e/1FAIpQLSf5XyfkM8z_eDWAY3X2RTiFcQCYF9jhRztmXWBpoFNkL7VNjQ/viewform?embedded=true" 
          className="w-full h-screen border-0"
          title="Google Form"
        >
          Loading form...
        </iframe>
      </main>
      
      <footer className="w-full max-w-4xl mt-6 text-center text-gray-500 text-sm">
        <p>Form provided via Google Forms</p>
      </footer>
    </div>
  );
}